// AUTO-GENERATED FILE — do not edit by hand.
// Generated from package.json by scripts/generate-version.js
// Runs automatically via the `prestart` and `prebuild` npm lifecycle hooks.
export const APP_VERSION = '1.40.7';
